export enum PlayResult {
	mediaElementNotFound = "mediaElementNotFound",
	canNotPlay = "canNotPlay",
	isNotReady = "isNotReady",
	notAllowed = "notAllowed",
	unknownError = "unknownError",
	timeout = "timeout",
	ok = "ok",
}
